<template>
	<div class="juniper-container" :class="{ 'dashboard-dark': dashboardDark }">
		<OnboardingSidebar v-if="!hideSidebarForRoute" @toggle="onSidebarToggle" />
		<div class="juniper-content" :class="{ 'sidebar-collapsed': sidebarCollapsed && !hideSidebarForRoute, 'no-sidebar': hideSidebarForRoute }">
			<div class="juniper-scrollable">
				<div :class="contentWrapperClass">
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import OnboardingSidebar from '@/components/onboarding/layout/Sidebar.vue'
import { mapGetters, mapState } from 'vuex'
export default {
	name: 'OnboardingDashboard',
	components: { OnboardingSidebar },
	data() {
		return {
			sidebarCollapsed: localStorage.getItem('onboarding-sidebar-collapsed') === 'true',
		}
	},
	computed: {
		...mapState(['authUser', 'dashboardDark']),
		...mapGetters(['isAuth']),
		// The progress page is a focused full-screen flow — no sidebar there.
		hideSidebarForRoute() {
			return ['onboardingProgress'].includes(this.$route.name)
		},
		// Dashboard home and settings render centered; the list is full-width
		// like Juniper Clients; the rest bring their own .container.
		contentWrapperClass() {
			if (['onboarding', 'onboardingOptions'].includes(this.$route.name)) return 'container py-3 pb-5'
			if (this.$route.name === 'onboardingList') return 'container-fluid py-3 pb-5'
			return 'pb-5'
		},
	},
	mounted() {
		this.syncDashboardTheme(this.dashboardDark)
	},
	beforeDestroy() {
		document.body.classList.remove('dashboard-dark')
	},
	watch: {
		dashboardDark(newValue) {
			this.syncDashboardTheme(newValue)
		},
	},
	methods: {
		onSidebarToggle(collapsed) {
			this.sidebarCollapsed = collapsed
		},
		syncDashboardTheme(isDark) {
			document.body.classList.toggle('dashboard-dark', isDark)
		},
	},
}
</script>

<style scoped>
.juniper-container {
	display: flex;
	height: 100vh;
	overflow: hidden;
	width: 100%;
}

.juniper-content {
	flex: 1;
	margin-left: 200px;
	transition: margin-left 0.3s ease;
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: hidden;
}

.juniper-content.sidebar-collapsed {
	margin-left: 60px;
}

.juniper-content.no-sidebar {
	margin-left: 0;
}

.juniper-scrollable {
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
}

@media (max-width: 768px) {
	.juniper-content {
		margin-left: 0 !important;
	}
}
</style>
